module.exports = __webpack_public_path__ + "img/logo.0ea7c254.png";